"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

interface LayoutWrapperProps {
  children: ReactNode;
  navbar?: ReactNode;
  footer?: ReactNode;
}

export const LayoutWrapper = ({
  children,
  navbar,
  footer,
}: LayoutWrapperProps) => {
  const pathname = usePathname();
  const isAuthRoute =
    pathname?.startsWith("/signin") ||
    pathname?.startsWith("/forgot-password") ||
    pathname?.startsWith("/reset-password");

  if (isAuthRoute) {
    return children;
  }

  return (
    <>
      {navbar}
      {children}
      {footer}
    </>
  );
};
